import { Chart } from '@repo/shared/dtos/assistant'
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  type ChartOptions,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js'
import { Bar, Line, Pie } from 'react-chartjs-2'

ChartJS.register(
  ArcElement,
  BarElement,
  CategoryScale,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
)

export type SimpleChartOptions = {
  responsive: boolean
  maintainAspectRatio: boolean
  plugins: {
    legend: {
      position: 'top' | 'bottom' | 'left' | 'right' | 'center'
    }
  }
}

export function ChartComponent({
  chart,
  options,
}: {
  chart: Chart
  options: ChartOptions<'line'> | ChartOptions<'pie'> | ChartOptions<'bar'>
}) {
  if (chart.type === 'pie') {
    return <Pie data={chart.payload} options={options as ChartOptions<'pie'>} />
  } else if (chart.type === 'bar') {
    return <Bar data={chart.payload} options={options as ChartOptions<'bar'>} />
  } else if (chart.type === 'line') {
    return <Line data={chart.payload} options={options as ChartOptions<'line'>} />
  }
}
